import { replace } from "utils/Utils";
import { FetchOrganizationEndAction } from "../actions/FetchOrganization";
import { OrgState } from "../state";

export function fetchOrganization(state: OrgState, action: FetchOrganizationEndAction) {
    const { error, organization, selectOnSuccess } = action.payload;
    const newState: Partial<OrgState> = { error };

    if (selectOnSuccess) {
        newState.orgs = replace(state.orgs, organization, "organizationId");
        newState.currentOrg = organization;
        newState.currentPaymentSummary = undefined;
        newState.currentAvailableAppsSummary = undefined;
    }
    return { ...state, ...newState };
}
